<template>
    <svg class="mr-2" width="16" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16 10.08V7.39c0-.4-.12-.8-.3-1.14L14 3.33a1.1 1.1 0 00-.97-.57h-2.57c-.4 0-.75.35-.75.75v6.11h-.57v-8C9.14 1 8.63.48 8 .48H0v10.28h1.71a2.33 2.33 0 012.23-1.71c1.09 0 2 .74 2.23 1.71h4.17a2.33 2.33 0 012.23-1.71c.91 0 1.66.51 2 1.26.17.28.45.45.74.45.4 0 .74-.34.68-.68zm-5.14-3.32V3.91h2.28l1.66 2.85h-3.94z"
            fill="#51747D"
        />
        <path
            d="M12.57 9.62c-.97 0-1.71.74-1.71 1.71 0 .98.74 1.72 1.71 1.72s1.71-.74 1.71-1.72c0-.97-.74-1.71-1.71-1.71zm0 2.51a.78.78 0 01-.8-.8c0-.45.34-.8.8-.8s.8.35.8.8c0 .46-.34.8-.8.8zM4 9.62c-.97 0-1.71.74-1.71 1.71 0 .98.74 1.72 1.71 1.72s1.71-.74 1.71-1.72c0-.97-.74-1.71-1.71-1.71zm0 2.51a.78.78 0 01-.8-.8c0-.45.34-.8.8-.8s.8.35.8.8c0 .46-.34.8-.8.8z"
            fill="#51747D"
        />
        <path
            d="M4 11.62a.29.29 0 100-.57.29.29 0 000 .57zM12.57 11.62a.29.29 0 100-.57.29.29 0 000 .57z"
            fill="#51747D"
        />
    </svg>
</template>
